/**
 * 카드 상세 페이지 > 재발급 동선인 경우 파라미터를 체크하여 로직을 처리한다.
 * 새로고침을 대응하기 위해 세션에 저장한다.
 * */
const CARD_REISSUE_SESSION_KEY = 'card-reissue';

const setIsReIssueSession = () => {
  sessionStorage.setItem(CARD_REISSUE_SESSION_KEY, 'true');
};
const getIsReIssueSession = () => {
  return sessionStorage.getItem(CARD_REISSUE_SESSION_KEY) === 'true';
};

const searchParas = new URLSearchParams(window.location.search);
const reIssueParam = searchParas.get('reissue');
const isReIssue = (reIssueParam === 'true' && setIsReIssueSession()) || getIsReIssueSession();
export {isReIssue};
